module.exports = __webpack_public_path__ + "img/城市.2410ddc8.gif";